export default class CategoriesInterector {

  constructor(service) {
    this.service = service
  }

  getData() {
    return this.service.getData();
  }
}